import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import get from 'lodash/get';

import GOOGLE_API_KEY from '../../utils/googleAPIKey';

const style = {
  width: '100%',
  height: '27.25rem',
};

const containerStyle = {
  position: 'relative',
  maxWidth: '100%',
  height: '100%',
};

function MapContainer({ google, stores, store }) {
  const storeLat = get(store, 'fields.coordinates[1]', 37.9852805);
  const storeLng = get(store, 'fields.coordinates[0]', 23.7519884);
  return (
    <Map
      style={style}
      containerStyle={containerStyle}
      google={google}
      zoom={14}
      initialCenter={{
        lat: 37.9852805,
        lng: 23.7519884,
      }}
      center={{
        lat: storeLat,
        lng: storeLng,
      }}
    >
      {stores.map(s => (
        <Marker
          key={s.uuid}
          position={{
            lat: s.fields.coordinates[1],
            lng: s.fields.coordinates[0],
          }}
          icon={{
            url: `/assets/${process.env.appName}/brandPin.png`,
            anchor: new google.maps.Point(24, 32),
            scaledSize: new google.maps.Size(24, 32),
          }}
        />
      ))}
    </Map>
  );
}

export default GoogleApiWrapper({
  apiKey: GOOGLE_API_KEY,
  language: 'el',
})(MapContainer);
